export default function SetGlobalVariables() {
    // If running locally, set to localhost for dev, otherwise set to railway
    if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
    ) {
        window.serverIP = "http://localhost:3001";
    } else {
        window.serverIP = "https://cloudnote-server.up.railway.app";
    }

    console.log("Hostname:", window.location.hostname);

    window.supabaseURL = "https://nuuebuohredzoiqmvvta.supabase.co";
    window.supabasePublicKey =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im51dWVidW9ocmVkem9pcW12dnRhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE4OTkzODYsImV4cCI6MjA2NzQ3NTM4Nn0.E44tanK1nLMR__cPX6rz9ezyzxFZgwIhRTo1hVpUfcs";
}
